export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_FONT = "SET_FONT";
